import React, { useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import { getBanner } from "../../store/actions/banners_action";
import Spinner from "../../components/layout/Spinner";
import { inputFields } from "../../shared/enums/banners_enum";
import SingleView from "../../components/common/SingleView";
const ViewBanner = ({ getBanner, match, banner: { loading, banner } }) => {
  useEffect(() => {
    getBanner(match.params.id);
  }, [match]);
  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Banners"
          mainLinkTitle="Banners"
          mainLinkUrl="/banners"
          activeLink="View"
        />
        {!loading ? (
          banner && (
            <SingleView
              data={banner}
              inputFields={inputFields}
              label="Banner"
              link="banners"
              id={banner.id}
            />
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ banner: state.banner });

const mapDispatchToProps = { getBanner };

export default connect(mapStateToProps, mapDispatchToProps)(ViewBanner);
